import { render, staticRenderFns } from "./MenuContent.vue?vue&type=template&id=660138c6&"
import script from "./MenuContent.vue?vue&type=script&lang=ts&"
export * from "./MenuContent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports